import { render } from "./InfoVendedor.vue?vue&type=template&id=3a1441a0"
import script from "./InfoVendedor.vue?vue&type=script&lang=js"
export * from "./InfoVendedor.vue?vue&type=script&lang=js"

import "./InfoVendedor.vue?vue&type=style&index=0&id=3a1441a0&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__